// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"79461e61","361":"b9235207","387":"c3e0ae38","418":"a0336ba8","579":"c445710b","965":"699dedda"}[chunkId] + ".chunk.js";
};